import React, {useState} from 'react'
import phone from '../../assets/phone.svg'
import message from '../../assets/message.svg'
import location from '../../assets/location.svg'
import copy from '../../assets/copy.svg'
import styles from './Contact.module.css'


const Contact = () => {
    const[text, setText] = useState(true);


        function copyText(){
            navigator.clipboard.writeText('11111111111')
            setText(false)
            }

         setTimeout(() => {
            setText(true)
         }, 5000)

    
    
    
  return (
      <section id='contact'>
            <div className='container md:pl-[61px] md:pr-[57px]'>
                <h1 className='text my-[42px] md:mt-[92px] md:mb-[106px]'>Contact Us</h1>

                    <div className='flex flex-col sm:flex-row justify-center px-4 md:px-1'>
                        <div className='w-full sm:w-[50%] flex flex-col justify-center self-center px-[17px] bg-primary  md:w-[676px] xl:w-[337px] h-[247px] md:h-[499px] xl:h-[388px] z-30 relative xl:left-[120px]'>
                                <div className='flex'>
                                    <img className='w-[12px] md:w-[20px] h-[15px] md:h-[25px] mr-[3px] md:mr-[7px]' src={location} alt="/" />
                                    <h2 className='text-[13px] md:text-[17px] leading-[13px] md:leading-[30px] text-white tracking-[0.005em] '>B13 Lousiana Estate Dakwo</h2>
                                </div>
                                <div className='flex mt-[23px] md:mt-[52px]'>
                                    <img className='w-[12px] md:w-[20px] h-[15px] md:h-[25px] mr-[3px] md:mr-[7px]' src={message} alt="/" />
                                    <h2 className='text-[13px] md:text-[17px] leading-[13px] md:leading-[30px] text-white tracking-[0.005em] '>Hello@gmail.com</h2>
                                </div>
                                <div className='flex mt-[23px] md:mt-[52px] sm:justify-between'>
                                        <div className='flex '>
                                                <img className='w-[12px] md:w-[20px] h-[15px] md:h-[25px] mr-[3px] md:mr-[7px]' src={phone} alt="/" />
                                                <h2 className='text-[13px] md:text-[17px] leading-[13px] md:leading-[30px] text-white tracking-[0.005em] '>1111111111</h2>
                                        </div>
                                        <div className='flex flex-col items-center ml-3 md:ml-0'>
                                                <img onClick={() => copyText()} className='w-[12px] md:w-[20px] h-[15px] md:h-[25px] mr-[3px] md:mr-[7px] cursor-pointer' src={copy} alt="/" />
                                                {text ? (<h3 className='text-[13px] md:text-[17px] leading-[30px] text-white tracking-[0.005em]'>copy</h3>):
                                                (<h3 className='text-gold text-[13px] md:text-[17px] leading-[30px]  tracking-[0.005em]'>copied</h3>)}
                                        </div>
                                </div>
                        </div>
                        <div className={`w-full sm:w-[50%] md:flex justify-end md:w-[676px] h-[247px] md:h-[499px] md:pr-[30px] pl-[10px] relative xl:right-[120px] rounded-none ${styles.box}`}>
                                
                                <form className='flex flex-col items-center sm:items-start  xl:ml-[25px] md:mt-[48px] pr-2 md:pr-0'>
                                <div>
                                    <h1 className='text-center sm:text-left text-[14px] md:text-[22px] mt-[23px] md:mt-0 leading-[14px] md:leading-[28px] text-primary'>Get in touch</h1>
                                    <p className='text-[10px] md:text-[14px] mt-[8px] md:mt-[16px] leading-[12px] md:leading-[24px] tracking-[0.005em]'>Feel free to drop us a line below</p>
                                </div>
                                <input className='w-full md:w-[384px] py-3 h-[20px] md:h-[42px] mt-[7px] md:mt-[11px] px-[11px] bg-light text-xs placeholder:text-[8px] rounded-none outline-none md:placeholder:text-[14px] placeholder:leading-[11px] md:placeholder:leading-[24px] placeholder-placeholder ' type="text" placeholder='Your Name'/>
                                <input className='w-full md:w-[384px] py-3 mt-[7px] md:mt-[16px] px-[11px] h-[20px] md:h-[42px] bg-light text-xs rounded-none outline-none placeholder:text-[8px] md:placeholder:text-[14px] placeholder:leading-[11px] md:placeholder:leading-[24px] placeholder-placeholder' type="email" placeholder='Your Email'/>
                                <textarea className='w-full  md:w-[384px] py-3 mt-[7px] md:mt-[16px] px-[11px] h-[63px] md:h-[135px] bg-light text-xs rounded-none outline-none placeholder:text-[8px] md:placeholder:text-[14px] placeholder:leading-[11px] md:placeholder:leading-[24px] placeholder-placeholder'  placeholder='Enter your text here'/>
                                <button className='w-full md:w-[384px] h-[23px] md:h-[49px] hover:bg-hover active:bg-active  text-white bg-primary mt-[13px] md:mt-[38px] text-[12px] md:text-[14px] md:leading-[20px] md:tracking-[0.001em] font-bold '>Send</button>
                                </form>
                        </div>
                    </div>

                    {/* for very small devices */}

            </div>
      </section>
    
  )
}

export default Contact